var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_55533",
    "data-name": "Group 55533",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.891,
    height: 50.071,
    viewBox: "0 0 44.891 50.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_85355",
    "data-name": "Path 85355",
    d: "M50.028,18.539H45.711V42.711a.863.863,0,0,1-1.727,0V6.453A3.452,3.452,0,0,0,40.532,3H9.453A3.452,3.452,0,0,0,6,6.453V47.028a6.05,6.05,0,0,0,6.043,6.043H44.848a6.05,6.05,0,0,0,6.043-6.043V19.4A.866.866,0,0,0,50.028,18.539ZM37.942,29.762H27.582a.863.863,0,0,1,0-1.727H37.942A.863.863,0,0,1,37.942,29.762Zm0,6.043h-25.9a.863.863,0,0,1,0-1.727h25.9A.863.863,0,0,1,37.942,35.805Zm0-12.518H27.582a.863.863,0,0,1,0-1.727H37.942A.863.863,0,0,1,37.942,23.287Zm0-6.475H27.582a.863.863,0,0,1,0-1.727H37.942A.863.863,0,0,1,37.942,16.813Zm-25.9-7.77h25.9a.863.863,0,0,1,0,1.727h-25.9a.863.863,0,0,1,0-1.727Zm-.863,8.633a2.6,2.6,0,0,1,2.59-2.59h6.906a2.6,2.6,0,0,1,2.59,2.59v9.5a2.6,2.6,0,0,1-2.59,2.59H13.77a2.6,2.6,0,0,1-2.59-2.59ZM37.942,41.848h-25.9a.863.863,0,0,1,0-1.727h25.9A.863.863,0,0,1,37.942,41.848Z",
    transform: "translate(-6 -3)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85356",
    "data-name": "Path 85356",
    d: "M14.863,30.223H21.77a.866.866,0,0,0,.863-.863v-9.5A.866.866,0,0,0,21.77,19H14.863a.866.866,0,0,0-.863.863v9.5A.866.866,0,0,0,14.863,30.223Z",
    transform: "translate(-7.094 -5.188)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournal);
export default __webpack_public_path__ + "static/media/journal.521dbe0f57c61dbac84096c0337444ce.svg";
export { ForwardRef as ReactComponent };